import { render, staticRenderFns } from "./PersonalAttendancePage.vue?vue&type=template&id=b54e4320&scoped=true&"
import script from "./PersonalAttendancePage.vue?vue&type=script&lang=js&"
export * from "./PersonalAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54e4320",
  null
  
)

export default component.exports